import * as Yup from "yup";

/**
 * Compliance does not accept a PO Box as a residential address. Matches "PO Box 72",
 * "P.O. Box 72", "P/O Box 5", "po  box 215", "POBox 5", "PO Box 12A", "PO Box: 12",
 * "Post Box 5", "Post Office Box 9", "GPO Box 1", a bare "PO Box" (e.g. typed into
 * the unit field), "Locked Bag 4", "Private Bag 7" and "PMB 12" — but not place
 * names such as "Box Hill" or "Boxwood Ave", because a PO/Post/GPO prefix is
 * required before "Box".
 *
 * Keep in sync with libs/utils/src/lib/po-box.ts, which strips the same pattern from
 * any address the backend sends to Salesforce.
 */
const PO_PREFIX = String.raw`(?:(?:g[\s.]*)?p[\s./-]*o\.?|post(?:\s+office)?)`;
const BOX_NUMBER = String.raw`[\s:#-]*(?:no\.?\s*)?\d+[a-z]?\b`;
const PO_BOX_PATTERN = new RegExp(
  [
    // "Box" must not run into a word ("Boxwood"); the number is optional.
    String.raw`\b${PO_PREFIX}[\s-]*box(?![a-z])(?:${BOX_NUMBER})?`,
    String.raw`\b(?:locked|private)\s+bag${BOX_NUMBER}`,
    String.raw`\bpmb${BOX_NUMBER}`,
  ].join("|"),
  "i",
);

export const PO_BOX_ERROR_MESSAGE = "PO Boxes are not accepted. Please enter a residential address";

export const containsPoBox = (value?: string | null): boolean =>
  !!value && PO_BOX_PATTERN.test(value);

/** Adds the PO Box rejection to a Yup string schema (an optional field by default). */
export const rejectPoBox = (schema: Yup.StringSchema = Yup.string()): Yup.StringSchema =>
  schema.test("no-po-box", PO_BOX_ERROR_MESSAGE, (value) => !containsPoBox(value));
